import { Box, Tooltip } from '@mui/material';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import { STATUS, STATUS_NAO_COBRADA } from './financeiroUtils';

// Etiqueta do semáforo: bolinha colorida + nome do status.
// Quando o status foi corrigido na mão, mostra um lápis e explica no tooltip.
// status="nao_cobrada": NF de projeto cancelado que não será cobrada (etiqueta cinza).
export default function StatusChip({ status, corrigido = false, automatico, pequeno = false }) {
  const meta = status === 'nao_cobrada' ? STATUS_NAO_COBRADA : (STATUS[status] || STATUS.a_receber);

  const chip = (
    <Box
      component="span"
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.75,
        px: pequeno ? 1 : 1.25, py: pequeno ? 0.25 : 0.5,
        borderRadius: 99, backgroundColor: meta.fundo, color: meta.texto,
        fontSize: pequeno ? 12 : 13, fontWeight: 600, lineHeight: 1.3, whiteSpace: 'nowrap',
      }}
    >
      <Box
        component="span" aria-hidden="true"
        sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: meta.cor, flexShrink: 0 }}
      />
      {meta.label}
      {corrigido && <EditNoteRoundedIcon sx={{ fontSize: 15 }} />}
    </Box>
  );

  if (!corrigido) return chip;
  return (
    <Tooltip title={`Status corrigido manualmente. O sistema calculou: ${STATUS[automatico]?.label || '—'}.`}>
      {chip}
    </Tooltip>
  );
}
